import React from 'react';
import PropTypes from 'prop-types';
import { map, reduce } from 'lodash';
import { withPropsOnChange } from 'recompose';

import { unitPropType } from 'config/propTypes';
import {
	storageStackedUnitBuckets,
	vehicleStackedUnitBuckets,
} from 'config/units';

import NewStackedUnit from './NewStackedUnit';

export function emptyStorageUnit(size) {
	const unit = {
		quantity: 0,
		placeholder: true,
	};
	switch (size) {
		case 'largeUnit':
			unit.size = "10' x 10'";
			break;
		case 'mediumUnit':
			unit.size = "5' x 10'";
			break;
		default:
			unit.size = "5' x 5'";
	}

	return unit;
}

export const enhance = withPropsOnChange(
	['units', 'storageType'],
	({ facility, units, storageType, searchParams }) => {
		let stackedUnits = [];
		if (storageType === 'vehicle') {
			// Grab the first 3 available vehicle buckets
			stackedUnits = reduce(
				vehicleStackedUnitBuckets,
				(stack, bucket) =>
					units[bucket] ? [...stack, units[bucket]] : stack,
				[],
			).slice(0, 3);
			if (searchParams.length) {
				stackedUnits = stackedUnits.filter((unit) => {
					const rangeLength = searchParams.length.split('-');
					const unitLength = parseFloat(unit.length);
					return (
						unitLength >= parseFloat(rangeLength[0]) &&
						unitLength <= parseFloat(rangeLength[1])
					);
				});
			}
		} else {
			stackedUnits = map(storageStackedUnitBuckets, (size) => {
				if (searchParams?.sqft) {
					if (!units[size]) return units[size];
					const rangeSQFT = searchParams.sqft.split('-');
					const sqft = units[size].squareFootage;
					if (
						sqft >= Number(rangeSQFT[0]) &&
						sqft <= Number(rangeSQFT[1])
					) {
						return units[size];
					}
					return null;
				}
				return units[size] || emptyStorageUnit(size);
			});
		}
		return {
			stackedUnits,
			unitsAvailable: units.unitsAvailable,
			moreUnitsText: units.moreUnitsText,
			facilityId: facility.id,
			facilityUrl: facility.url,
			facility,
		};
	},
);

export function NewStackedUnits({
	facilityId,
	stackedUnits,
	facility,
	baseUrl,
}) {
	return (
		<div className="new-stacked-units">
			{stackedUnits.map(
				(unit, index) =>
					unit && (
						<NewStackedUnit
							key={unit.id || `${facilityId}-${index}`}
							facilityId={facilityId}
							unit={unit}
							facility={facility}
							baseUrl={baseUrl}
						/>
					),
			)}
		</div>
	);
}

NewStackedUnits.propTypes = {
	facilityId: PropTypes.number.isRequired,
	stackedUnits: PropTypes.arrayOf(unitPropType).isRequired,
	baseUrl: PropTypes.string,
	facility: PropTypes.object,
};

export default enhance(NewStackedUnits);
